import axios, { AxiosError, AxiosResponse } from 'axios'
const { REACT_APP_ENDPOINT } = process.env

export async function postAuthorize(email: string, password: string) {
  const client_id = new URLSearchParams(window.location.search).get('client_id')
  const redirect_uri = new URLSearchParams(window.location.search).get('redirect_uri')
  const response_type = new URLSearchParams(window.location.search).get('response_type')
  const scope = new URLSearchParams(window.location.search).get('read')
  const state = new URLSearchParams(window.location.search).get('state')
  const code_challenge = new URLSearchParams(window.location.search).get('code_challenge')
  const code_challenge_method = new URLSearchParams(window.location.search).get('code_challenge_method')
  const data = {
    client_id,
    email: email.trim(),
    password,
    redirect_uri,
    response_type,
    scope,
    state,
    code_challenge,
    code_challenge_method,
  }
  return await axios
    .post(`${REACT_APP_ENDPOINT}/v1:authorize`, data)
    .then((response: AxiosResponse) => {
      if (response.data.code) {
        return Promise.resolve(response.data)
      } else {
        return Promise.reject(false)
      }
    })
    .catch((error: AxiosError) => {
      console.log('[postAuthorize()]' + JSON.stringify(error.response ? error.response['data']['message'] : undefined))
      return Promise.reject(error.response ? error.response['data']['message'] : undefined)
    })
}

export async function postThirdPartyAuthorize(service: string, token: string) {
  let body: any = {}
  const client_id = new URLSearchParams(window.location.search).get('client_id')
  if (client_id != null) {
    body['client_id'] = client_id
  }
  const code_challenge = new URLSearchParams(window.location.search).get('code_challenge')
  if (code_challenge != null) {
    body['code_challenge'] = code_challenge
  }
  const code_challenge_method = new URLSearchParams(window.location.search).get('code_challenge_method')
  if (code_challenge_method != null) {
    body['code_challenge_method'] = code_challenge_method
  }
  body['third_party_name'] = service
  if (service === 'facebook') {
    body['access_token'] = token
  } else if (service === 'google') {
    body['authorization_code'] = token
  } else if (service === 'apple') {
    body['authorization_code'] = token
  } else {
    return
  }

  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  }
  return await axios
    .post(`${REACT_APP_ENDPOINT}/v1:thirdPartyAuthorize`, JSON.stringify(body), config)
    .then((response: AxiosResponse) => {
      if (response.data.code) {
        return Promise.resolve(response.data)
      } else {
        return Promise.reject(false)
      }
    })
    .catch((error: AxiosError) => {
      console.log(
        '[postThirdPartyAuthorize()]' + JSON.stringify(error.response ? error.response['data']['message'] : undefined)
      )
      return Promise.reject(error.response ? error.response['data']['message'] : undefined)
    })
}

export async function postFirebaseAuthorize(idToken: string) {
  const params = new URLSearchParams(window.location.search)
  const data = {
    id_token: idToken,
    client_id: params.get('client_id'),
    redirect_uri: params.get('redirect_uri'),
    response_type: params.get('response_type'),
    scope: params.get('read'),
    state: params.get('state'),
    code_challenge: params.get('code_challenge'),
    code_challenge_method: params.get('code_challenge_method'),
  }
  return await axios
    .post(`${REACT_APP_ENDPOINT}/v1:firebaseAuthorize`, data)
    .then((response: AxiosResponse) => {
      if (response.data.code) {
        return Promise.resolve(response.data)
      } else {
        return Promise.reject(false)
      }
    })
    .catch((error: AxiosError) => {
      console.log(
        '[postFirebaseAuthorize()]' + JSON.stringify(error.response ? error.response['data']['message'] : undefined)
      )
      return Promise.reject(error.response ? error.response['data']['message'] : undefined)
    })
}

export async function postForgotPassword(email: string) {
  const data = {
    email: email.trim(),
  }
  return await axios
    .post(`${REACT_APP_ENDPOINT}/v1:forgotPassword`, data)
    .then((response: AxiosResponse) => {
      if (response.status === 200) {
        return Promise.resolve(true)
      } else {
        return Promise.reject(false)
      }
    })
    .catch((error: AxiosError) => {
      console.log(
        '[postForgotPassword()]' + JSON.stringify(error.response ? error.response['data']['message'] : undefined)
      )
      return Promise.reject(error.response ? error.response['data']['message'] : undefined)
    })
}
